<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <vsud-alert v-if="showAlert" icon="fa fa-bell" dismissible="true" color="success">
            {{ msgAlert }}
        </vsud-alert>
        <users-table ></users-table>
      </div>
    </div>
  </div>
</template>

<script>
import UsersTable from "@/views/users/components/Table.vue";
import VsudAlert from "@/components/VsudAlert.vue";

export default {
  name: "users",
  data()
  {
    return {
      showAlert : false,
      msgAlert  : '',
    }
  },

  created ()
  {
    this.checkAlert();
  },

  components: 
  {
    UsersTable,
    VsudAlert
  },

  methods : 
  {
    checkAlert()
    {
      const status = this.$route.params.status;
      const token  = this.$store.state.alertToken;

      if(token==status&&token!='')
      {
        this.showAlert = true;
        this.msgAlert  = 'User addedd successfully';
        this.$store.dispatch('setAlertToken', '');
      }
    }
  }
};
</script>